<template>
  <md-dialog-confirm
    :md-active.sync="open"
    md-title="Daily limit reached"
    :md-content="body"
    md-confirm-text="Upgrade for unlimited access"
    md-cancel-text="Close"
    @md-confirm="upgrade"
  />
</template>

<script>
import { mapGetters } from "vuex";
// Same "Upgrade Account" booking link the navbar uses (pages/Layout/MainNavbar.vue).
// same link as the navbar "Upgrade Account" button (master imports it from AskBizminer/chatCore)
const UPGRADE_URL = "https://bizminer.pipedrive.com/scheduler/qllvp0s0/bizmineraccount-upgrade";

// Opened by the global axios interceptor (store/modules/error-handler-module.js) when the API
// answers errorCode "daily_limit_reached". Mounted once in App.vue.
export default {
  name: "daily-limit-dialog",
  computed: {
    ...mapGetters({ isOpen: "dailyLimitOpen", limit: "dailyLimit" }),
    open: {
      get() {
        return this.isOpen;
      },
      set(newValue) {
        this.$store.commit("SET_DAILY_LIMIT_OPEN", newValue);
      },
    },
    body() {
      const reset = "Your limit resets 24 hours after your earlier reports.";
      return this.limit
        ? "Free accounts can create up to " + this.limit + " of these per day. " + reset
        : "Free accounts have a daily limit for this report. " + reset;
    },
  },
  methods: {
    upgrade() {
      window.open(UPGRADE_URL, "_blank", "noopener");
    },
  },
};
</script>
